import type { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TransitionWrapper from "../../../components/common/transition-wrapper";

interface BossBottomTabProps {
  topNotice?: ReactNode;
}

const BossBottomTab = ({ topNotice }: BossBottomTabProps): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="z-10 fixed bottom-0 w-full max-w-[742px]">
      {topNotice}
      <div className="flex justify-evenly items-center bg-white h-[64px] shadow-[0px_-2px_26px_#00000026]">
        {/* Order History Tab */}
        <TransitionWrapper scale={0.8} opacity={0.5}>
          <div
            className={`flex flex-col items-center ${
              location.pathname === "/boss/pre-order/home"
                ? "opacity-100"
                : "opacity-40"
            }`}
            onClick={() => navigate("/boss/pre-order/home")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M11.5 10H15.7143M11.5 14H15.7143M8.28571 10H8.29643M8.28571 14H8.29643M15.7143 4H6.14286C5.57454 4 5.02949 4.21071 4.62763 4.58579C4.22576 4.96086 4 5.46957 4 6V18C4 18.5304 4.22576 19.0391 4.62763 19.4142C5.02949 19.7893 5.57454 20 6.14286 20H17.8571C18.4255 20 18.9705 19.7893 19.3724 19.4142C19.7742 19.0391 20 18.5304 20 18V6C20 5.46957 19.7742 4.96086 19.3724 4.58579C18.9705 4.21071 18.4255 4 17.8571 4H15.7143Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-center mb-0.5 text-lg font-semibold">예약판매</p>
          </div>
        </TransitionWrapper>

        {/* Home Tab */}
        <TransitionWrapper scale={0.8} opacity={0.5}>
          <div
            className={`flex flex-col items-center ${
              location.pathname === "/boss/home" ? "opacity-100" : "opacity-40"
            }`}
            onClick={() => navigate("/boss/home")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H9M19 10L21 12M19 10V20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H15M9 21C9.26522 21 9.51957 20.8946 9.70711 20.7071C9.89464 20.5196 10 20.2652 10 20V16C10 15.7348 10.1054 15.4804 10.2929 15.2929C10.4804 15.1054 10.7348 15 11 15H13C13.2652 15 13.5196 15.1054 13.7071 15.2929C13.8946 15.4804 14 15.7348 14 16V20C14 20.2652 14.1054 20.5196 14.2929 20.7071C14.4804 20.8946 14.7348 21 15 21M9 21H15"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-center text-lg font-semibold break-keep">
              실시간판매
            </p>
          </div>
        </TransitionWrapper>

        {/* My Page Tab */}
        <TransitionWrapper scale={0.8} opacity={0.5}>
          <div
            className={`pt-1.5 flex flex-col items-center ${
              location.pathname === "/boss/my" ? "opacity-100" : "opacity-40"
            }`}
            onClick={() => navigate("/boss/my")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M12.828 12.828C12.0779 13.5779 11.0607 13.9991 10 13.9991C8.93934 13.9991 7.92211 13.5779 7.172 12.828M7 8H7.01M13 8H13.01M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-center text-lg font-semibold">마이페이지</p>
          </div>
        </TransitionWrapper>
      </div>
    </div>
  );
};

export default BossBottomTab;
